<template>
  <nav
    class="navbar navbar-expand navbar-dark bg-dark"
    :class="{ logged: isLoggedIn }"
    id="barra-superior"
  >
    <div class="container">
      <div class="navbar-header">
        <router-link class="navbar-brand" to="/">
          <img src="/img/logo.svg" width="30px" /> Cruvi Móvil
        </router-link>
      </div>
      <ul class="nav navbar-nav">
        <router-link
          v-if="!isLoggedIn"
          class="nav-item nav-link"
          :to="{ name: 'Login' }"
          id="login-link"
        >
          Login
        </router-link>
        <router-link
          v-if="isLoggedIn"
          class="nav-item nav-link"
          :to="{ name: 'Dashboard' }"
        >
          <i class="fas fa-users-cog"></i>
        </router-link>
        <a
          class="nav-item nav-link"
          v-if="isLoggedIn"
          @click.prevent="logout"
          href="#"
          title="Cerrar Sesión"
        >
          <i class="fas fa-power-off"></i>
        </a>
      </ul>
    </div>
  </nav>
</template>

<script>
import User from "@/apis/User";

export default {
  computed: {
    isLoggedIn() {
      return this.$store.state.token != null;
    }
  },
  methods: {
    logout() {
      User.logout().then(() => {
        localStorage.removeItem("token");
        this.isLoggedIn = false;
        //this.$router.push({ name: "Login" });
        window.location = "/login";
      });
    }
  }
};
</script>

<style>
.router-link-exact-active {
  color: #ffffff !important;
  transition: all 0.25s;
}
</style>
